import { z } from "zod"
import { requiredErrorMessage } from "./required"

export const emailSchema = z.email({
  error: ({ input }) =>
    !input ? requiredErrorMessage : "Errors.notValidEmail",
})
